import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { FaArrowLeft, FaEdit, FaTrash } from "react-icons/fa";
import { CurrentUserContext } from "../../../../App";
import * as adminApi from "../../../../service/adminApi";
import { RedirectCode400 } from "../../../RedirectCode400";

function ViewDocument() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [titlepage, setTitlePage] = useState("");
  const [titleValue, setTitleValue] = useState("");
  const [defaultOption, setDefaultOption] = useState("");

  useEffect(() => {
    if (location.state?.type === "document") {
      setTitlePage(location.state?.title || "No Title");
      setTitleValue(location.state?.type || "");
      setDefaultOption("1");
    } else {
      navigate("/");
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location, navigate]);

  const formatDate = (date) => {
    if (!date || typeof date !== "string") {
      return "ไม่ระบุ"; // กรณีที่ `date` ไม่มีค่า หรือไม่ใช่ string
    }

    const monthsThai = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];

    const [year, month, day] = date.split("-");
    if (!year || !month || !day) {
      return "ไม่ระบุ";
    }

    return `${parseInt(day)} ${monthsThai[parseInt(month) - 1]} ${year}`;
  };

  const DownloadDocument = (file) => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: " pointer",
        }}
      >
        <span style={{ fontSize: "24px" }}>📄</span>
        <a
          href={file.file}
          target="_blank"   
          rel="noreferrer"  
          style={{ 
            textDecoration: "none", 
            color: "blue",
            cursor: "pointer" 
          }}
        >
          ดูเอกสาร (เปิดหน้าใหม่)
        </a>
      </div>
    );
  };

  const row = [
    {
      title: "ชื่อหัวข้อ",
      detail: location.state?.title ?? "ไม่มีข้อมูล",
    },
    {
      title: "ไฟล์เเนบ",
      detail: location.state?.file ? (
        <DownloadDocument file={location.state.file} />
      ) : (
        "ไม่มีข้อมูล"
      ),
    },
    {
      title: "สร้างโดย",
      detail: location.state?.title || "ไม่มีข้อมูล",
    },
    {
      title: "วันที่สร้าง",
      detail: formatDate(location.state?.create_date) || "ไม่ระบุ",
    },
    {
      title: "วันที่แก้ไข",
      detail: formatDate(location.state?.update_date) || "ไม่ระบุ",
    },
  ];

  // console.log(row);

  const handleRemoveDocument = async (item) => {
    if (!window.confirm(`คุณต้องการลบ ${location.state?.title} ใช่หรือไม่`))
      return;
    try {
      const res = await adminApi.removeDocument(item.document_id);
      if (res?.data?.code === 200) {
        navigate("/admin/management/document", {
          state: {
            type: "document",
          },
        });
      } else {
        setIsMessage({
          type: "warning",
          data: res?.data?.message_th || res?.data?.message,
        });
      }
    } catch (error) {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    <div className="min-w-[376px] overflow-x-auto">
      <div className="flex flex-row justify-between items-center mb-[10px]">
        <div className="text-3xl md:text-[18px] text-[#747081]">
          {titlepage}
        </div>
        <div className="flex flex-row gap-2">
          <button
            onClick={() =>
              navigate("/admin/management/document", {
                state: {
                  type: "document",
                },
              })
            }
            className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
            style={{ background: "#FFCC99 0% 0% no-repeat padding-box" }}
          >
            <FaArrowLeft style={{ color: "orange" }} />
          </button>
          <button
            className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
            style={{ background: "#FCD8DB 0% 0% no-repeat padding-box" }}
            onClick={() => handleRemoveDocument(location.state?.id)}
          >
            <FaTrash style={{ color: "red" }} />
          </button>
        </div>
      </div>
      <div className="flex flex-row rounded-[6px] border-[#E2E2E4] border min-w-[400px] md:w-[100%] md:min-w-[300px] p-[9px_16px] w-full">
        <div className="flex flex-col w-full">
          {row.map((item, index) => (
            <div key={index} className="flex flex-row mb-[10px]">
              <div className="w-[30%] font-bold text-[16px] sm:text-[14px]">
                {item.title}
              </div>
              <div className="w-[70%] break-words whitespace-normal text-[16px] sm:text-[14px] text-[#A9A7B1]">
                {item.detail}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ViewDocument;
